import { Application, AppStatuses } from '../../gql/graphql';
import { PAST_APPROVED_STATUSES } from '../../constants/app-status';
import { koalafiRoles, merchantRoles, Role } from '../../types/role';
import { ValidatedByTokenType } from '../../state-machine/types/ecommMachine.types';

interface ContractSummaryContext {
  contractSummaryPageParam: boolean;
  merchantContractSummaryPageParam: boolean;
  highestSupportedApplicationMilestone: number;
  role: Role;
  application?: Application;
  validatedByTokenType?: ValidatedByTokenType;
}

function m4AndAppStatusPastApproved(ctx: ContractSummaryContext): boolean {
  const isMilestone4 = ctx.highestSupportedApplicationMilestone > 3;
  const appStatusPastApproved = PAST_APPROVED_STATUSES.includes(ctx.application?.lease?.status as AppStatuses);
  return isMilestone4 && appStatusPastApproved;
}

export function canAccessContractSummaryPage(ctx: ContractSummaryContext): boolean {
  if (!ctx.contractSummaryPageParam) return false;
  const hasElevatedRole = [merchantRoles, koalafiRoles].some((arr) => arr.includes(ctx.role));
  return m4AndAppStatusPastApproved(ctx) && (hasElevatedRole || ctx.validatedByTokenType === ValidatedByTokenType.CONTRACT);
}

export function canAccessMerchantContractSummaryPage(ctx: ContractSummaryContext): boolean {
  if (!ctx.merchantContractSummaryPageParam) return false;
  const hasElevatedRole = [merchantRoles, koalafiRoles].some((arr) => arr.includes(ctx.role));
  return m4AndAppStatusPastApproved(ctx) && hasElevatedRole;
}

export function canAccessLeaseAgreement(role: Role, milestone: number, appStatus?: AppStatuses, token?: ValidatedByTokenType): boolean {
  const hasElevatedRole = [merchantRoles, koalafiRoles].some((arr) => arr.includes(role));
  const isMilestone4 = milestone > 3;
  const appStatusPastApproved = appStatus ? PAST_APPROVED_STATUSES.includes(appStatus) : false;
  const hasContractSummaryParam = new URLSearchParams(document.location.search).has('contractSummaryPage');

  if (isMilestone4 && appStatusPastApproved && hasContractSummaryParam) {
    if (hasElevatedRole || token === ValidatedByTokenType.CONTRACT) {
      return true;
    }
  }
  return false;
}

export function canAccessApplicationDetails(role: Role): boolean {
  const hasElevatedRole = [merchantRoles, koalafiRoles].some((arr) => arr.includes(role));
  const hasReviewPageParam = new URLSearchParams(document.location.search).get('reviewPage') === 'true';
  return hasElevatedRole && hasReviewPageParam;
}
